// DonutChart.jsx
import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const DonutChart = ({ chartdata, valueLabel = "Total", tooltipSuffix = "" }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    if (!chartdata || !chartdata.categories || !chartdata.series) {
      return;
    }

    const labels = chartdata.categories || [];
    const series = chartdata.series || [];

    if (!labels.length || !series.length) {
      return;
    }

    const chartConfig = {
      series,
      chart: {
        height: 350,
        type: "donut",
        toolbar: { show: true },
      },
      labels,
      legend: {
        position: "bottom",
        horizontalAlign: "center",
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(1) + "%";
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              total: {
                show: true,
                label: valueLabel, // 👈 dynamic
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                },
              },
            },
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return tooltipSuffix ? `${val} ${tooltipSuffix}` : val;
          },
        },
      },
    };

    chartInstance.current = new ApexCharts(chartRef.current, chartConfig);
    chartInstance.current.render();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [chartdata, valueLabel, tooltipSuffix]);

  return (
    <div>
      {!chartdata ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>No data available</p>
        </div>
      ) : (
        <div ref={chartRef}></div>
      )}
    </div>
  );
};

export default DonutChart;
